import React from "react";
import "./Footer.css";
import { Link } from "react-router-dom";
import { LocationOn, Phone, Email } from "@mui/icons-material";

const Footer = () => {
  return (
    <footer className="sgpgi-footer">
      <div className="footer-container">

        {/* Brand Info */}
        <div className="footer-col brand-col">
          <div className="footer-logo-row">
            <img src="/organizers/abstp.png" alt="ABSTP Logo" className="footer-logo-img" />
          </div>
          <p className="footer-desc">
            Association of Bone &amp; Soft Tissue Pathologists (ABSTP).
          </p>
          <div className="footer-event-box">
            <span className="footer-event-label">Upcoming Event</span>
            <p className="footer-event-name">2nd Biennial CME of ABSTP</p>
            <span className="footer-event-date">Oct 30 – Nov 1, 2026 · Lucknow</span>
          </div>
        </div>

        {/* Quick Links */}
        <div className="footer-col">
          <h4 className="footer-heading">Quick Links</h4>
          <ul className="footer-links-list">
            <li><Link to="/">Home</Link></li>
            <li><Link to="/about">About</Link></li>
            <li><Link to="/scientific-schedule">Scientific Schedule</Link></li>
            <li><Link to="/healthcare-education">Healthcare Education</Link></li>
            <li><Link to="/cases">Cases</Link></li>
            <li><Link to="/events">Events</Link></li>
            <li><Link to="/contact">Contact</Link></li>
          </ul>
        </div>

        {/* Contact */}
        <div className="footer-col">
          <h4 className="footer-heading">Contact</h4>
          <ul className="footer-contact-list">
            <li>
              <Email fontSize="small" className="footer-contact-icon" />
              <span>scope3181@gmail.com</span>
            </li>
            <li>
              <LocationOn fontSize="small" className="footer-contact-icon" />
              <span>A-1/217-A, Fourth Floor, Vishes Khand, Gomti Nagar, Lucknow, UP 226010, India</span>
            </li>
          </ul>
        </div>

        {/* Map — RMLIMS Lucknow */}
        <div className="map-card">
          <iframe
            title="RMLIMS Lucknow"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3559.4506644893617!2d80.92554607543064!3d26.851432376698073!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x399be3b9b80ef775%3A0x2c84c1d3d1c72ded!2sDr.%20Ram%20Manohar%20Lohia%20Institute%20of%20Medical%20Sciences!5e0!3m2!1sen!2sin!4v1751183400000!5m2!1sen!2sin"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>

      </div>

      {/* Footer Bottom Bar */}
      <div className="footer-bottom">
        <div className="footer-container bottom-container">
          <p className="copyright-text">
            © 2026 Association of Bone &amp; Soft Tissue Pathologists (ABSTP). All Rights Reserved.
          </p>
          <p>
            Powered by{" "}
            <a href="https://www.techbrj.com/" target="_blank" rel="noreferrer" className="footer-dev-link">
              TechBRJ
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
